import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";

type Product = {
  name: string;
  description: string;
  iconLink: string;
};

export const useCreateCategoryMutation = () => {
  return useMutation({
    mutationFn: (payload: Product) =>
      axiosInstance
        .post(`products/categories`, payload)
        .then((res: any) => res.data),
    onSuccess: async () => {},
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};
